// Payment.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Payment.css'; 

const Payment = () => {
  const [paymentData, setPaymentData] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
  });

  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPaymentData({
      ...paymentData,
      [name]: value,
    });
  };

  // Handle form submission
  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    // Here, you would integrate the actual payment processing logic
    console.log('Payment submitted:', paymentData);
    
    // After payment is successful, redirect to Google Authentication
    navigate('/google-auth');
  };

  return (
    <div className="payment-container">
      <h1 className="payment-title">Payment</h1>
      <form onSubmit={handlePaymentSubmit} className="payment-form">
        {/* Card Number */}
        <div className="payment-input-group">
          <label>Card Number</label>
          <input
            type="text"
            name="cardNumber"
            value={paymentData.cardNumber}
            onChange={handleChange}
            className="payment-input"
            placeholder="1234 5678 9012 3456"
          />
        </div>

        {/* Expiry Date and CVV */}
        <div className="payment-row">
          <div className="payment-input-group">
            <label>Expiry Date</label>
            <input
              type="text"
              name="expiryDate"
              value={paymentData.expiryDate}
              onChange={handleChange}
              className="payment-input"
              placeholder="MM/YY"
            />
          </div>
          <div className="payment-input-group">
            <label>CVV</label>
            <input
              type="text"
              name="cvv"
              value={paymentData.cvv}
              onChange={handleChange}
              className="payment-input"
              placeholder="123"
            />
          </div>
        </div>

        {/* Submit Payment Button */}
        <button type="submit" className="payment-submit-button">Submit Payment</button>
      </form>
    </div>
  );
};

export default Payment;
